var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { "data-component": "base-settings-empty-results" } },
    [
      _c("div", { staticClass: "title" }, [
        _vm._v("\n    " + _vm._s(_vm.title) + "\n  "),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "search-term-info" },
        [
          _vm.type === "no-search-results"
            ? [
                _vm.searchText
                  ? _c(
                      "or-label",
                      [
                        _c(
                          "i18n",
                          {
                            attrs: {
                              path: "HITL.common.search.no-results-description",
                            },
                          },
                          [
                            _c(
                              "strong",
                              {
                                attrs: { slot: "query", title: _vm.searchText },
                                slot: "query",
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(_vm.searchText) +
                                    "\n          "
                                ),
                              ]
                            ),
                          ]
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("or-label", [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm.$t("HITL.common.search.no-results-update-search")
                      ) +
                      "\n      "
                  ),
                ]),
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.descriptionText
            ? _c("or-label", [
                _vm._v("\n      " + _vm._s(_vm.descriptionText) + "\n    "),
              ])
            : _vm._e(),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }